/** Altitude color ramp: low = red, mid = yellow/green, high = blue. */

export const ALTITUDE_MAX_FT = 42_000;
export const ALTITUDE_BUCKETS = 12;

export function altitudeBucket(altitudeFt: number | null, onGround: boolean): number {
  if (onGround) return -1;
  if (altitudeFt == null) return Math.floor(ALTITUDE_BUCKETS / 2);
  const t = Math.min(Math.max(altitudeFt / ALTITUDE_MAX_FT, 0), 1);
  return Math.min(Math.floor(t * ALTITUDE_BUCKETS), ALTITUDE_BUCKETS - 1);
}

/** Hue sweep 0 (red) -> 230 (blue) across the altitude range. */
export function bucketColor(bucket: number): string {
  if (bucket < 0) return '#9aa0a6'; // on ground
  const t = bucket / (ALTITUDE_BUCKETS - 1);
  const hue = t * 230;
  return `hsl(${hue.toFixed(0)}, 90%, 55%)`;
}

export function altitudeColor(altitudeFt: number | null, onGround: boolean): string {
  return bucketColor(altitudeBucket(altitudeFt, onGround));
}

export function formatAltitude(altitudeFt: number | null, onGround: boolean): string {
  if (onGround) return 'GND';
  if (altitudeFt == null) return '---';
  if (altitudeFt >= 18_000) return `FL${Math.round(altitudeFt / 100)}`;
  return `${altitudeFt.toLocaleString()} ft`;
}
